export default "__VITE_ASSET__sMSV8xFf__";